import React from 'react';

import { MenuItemProps } from '../menu';

export interface SearchDialogInputRightProps {
  onClear?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  onClose?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  isShowClear?: boolean;
}

export interface SharedWithProps {
  name: string;
  photoUrl: string;
}

export interface SearchDataItemProps {
  id?: string;
  title?: string;
  workspace?: string;
  tags?: [any];
  isShared?: boolean;
  subTitle?: string;
  slug?: string;
  icon?: any;
  isDone?: boolean;
  sharedWith?: SharedWithProps[];
}

export interface SearchDataProps {
  total: number;
  items: SearchDataItemProps[];
}

export interface SearchDialogProps {
  getRecentSearches: () => Promise<SearchDataItemProps[]>;
  getSearchResult: (search: string, start: number, limit: number) => Promise<SearchDataProps>;
  onClose?: () => void;
  sortMenuOptions: {
    label: string;
    value: string;
  }[];
  filterMenuOptions: {
    label: string;
    value: string;
  }[];
  sortTxt: string;
  filterText: string;
  activeSortValue: { value: string; label: string };
  activeFilterValue: { value: string; label: string };
  onClickSortValue?: ((menuitem: MenuItemProps) => void) | undefined;
  onSelectSearchResult?: (item: SearchDataItemProps, postSearch: boolean) => void;
}

export interface SearchItemProps {
  title?: string;
  subTitle?: string;
  isShared?: boolean;
  icon?: any;
  tags?: any;
  isDone?: boolean;
  sharedWith?: SharedWithProps[];
  searchWords?: string[] | [];
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  isActive?: boolean;
  onMouseEnter?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export enum IconTypes {
  lesson = 'lesson',
  creation = 'creation',
}
